var ObjGaImpression = ObjGaImpression || {}
ObjGaImpression = {
  event: 'product-list-impressions',
  ecommerce: {
    impressions: [
    ]
  }
}

var ObjGaClic = ObjGaClic || {}
ObjGaClic = {
  event: 'product-click',
  label: '',
  ecommerce: {
    promoClick: {
      promotions: [
      ]
    }
  }
}

var ObjList = {
  name: '',
  id: '',
  brand: '',
  category: '',
  list: '',
  position: ''
}


// namespace and Revealing Module Pattern
var homeSuscripciones = (function () {
  var init = function () {
    var urlAjax = 'sources/assets/data/home-suscripciones.json'
    $.getJSON(urlAjax, function (data) {
      const urlExterno = (typeof data.url_suscripciones_externo !== undefined) ? data.url_suscripciones_externo : 'http:\/\/tienda.eltiempo.com'
      const urlInterno = (typeof data.url_suscripciones_externo !== undefined) ? data.url_suscripciones_interno : 'https:\/\/suscripciones.eltiempo.com'
      const urlRenovaciones = (typeof data.url_suscripciones_renovaciones !== undefined) ? data.url_suscripciones_renovaciones : 'http:\/\/renovaciones.eltiempo.com';
      (typeof data.digital !== 'undefined') ? _digital(data.digital, urlInterno) : false;
      (typeof data.ofertadestacada !== 'undefined') ? _ofertaDestacada(data.ofertadestacada, urlRenovaciones) : false;
      (typeof data.periodicos.eltiempo !== 'undefined') ? _periodicoEt(data.periodicos.eltiempo, urlInterno) : false;
      (typeof data.periodicos.portafolio !== 'undefined') ? _periodicoPo(data.periodicos.portafolio, urlInterno) : false;
      (typeof data.colecciones.coleccion !== 'undefined') ? _coleccion(data.colecciones.coleccion, urlExterno) : false;
      (typeof data.revistas !== 'undefined') ? _revistas(data.revistas, urlInterno) : false;
      (typeof data.revistas !== 'undefined') ? _slideRevistasGa(data.revistas, urlInterno) : false;
      (typeof data.libros !== 'undefined') ? _libros(data.libros, urlExterno) : false;
      (typeof data.cursos !== 'undefined') ? _cursos(data.cursos) : false;
      (typeof data.club_vivamos !== 'undefined') ? _clubVivamos(data.club_vivamos) : false;
      (typeof data.puntos_de_venta !== 'undefined') ? _puntosVenta(data.puntos_de_venta, urlExterno) : false;
      (typeof data.renovaciones !== 'undefined') ? _renovaciones(data.renovaciones, urlRenovaciones) : false;
      (typeof data.footer !== 'undefined') ? _footer(data.footer) : false;
      (typeof data.popupcookies !== 'undefined') ? _popupcookies(data.popupcookies) : false;

    })
  }

  var _digital = function (data, url) {
    const tituloDigital = document.querySelectorAll('.call-to-action-digital .titulo__call-to-action-digital')
    Object.keys(tituloDigital).forEach((key) => {
      let obj = tituloDigital[key]
      obj.innerHTML = (typeof data.titulo !== 'undefined') ? data.titulo : ''
    })

    const leadDigital = document.querySelectorAll('.call-to-action-digital__textos .call-to-action-digital__descripcion')
    Object.keys(leadDigital).forEach((key) => {
      let obj = leadDigital[key]
      obj.innerHTML = (typeof data.lead !== 'undefined') ? data.lead : ''
    })

    const btnDigital = document.querySelectorAll('.call-to-action-digital__textos .call-to-action-digital__enlace')
    Object.keys(btnDigital).forEach((key) => {
      let obj = btnDigital[key]
      obj.innerHTML = (typeof data.btn_text !== 'undefined') ? data.btn_text : ''
      obj.addEventListener('click', function (event) {
        window.open(url + data.btn_path, '_blank')
      })
    })
  }
  var _periodicoEt = function (data, url) {
    const leadEt = document.querySelectorAll('.periodicos .periodicos__eltiempo .periodicos__lead')
    Object.keys(leadEt).forEach((key) => {
      let obj = leadEt[key]
      obj.innerHTML = (typeof data.lead !== 'undefined') ? data.lead : ''
    })

    const btnEt = document.querySelectorAll('.periodicos .periodicos__eltiempo .periodicos__link')
    Object.keys(btnEt).forEach((key) => {
      let obj = btnEt[key]
      obj.innerHTML = (typeof data.btn_text !== 'undefined') ? data.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(data, "btnEt")
        var scriptTwo = _setGaEvent(data, "clickSuscripcion")
        window.open(url + data.btn_path, '_blank')
      })
    })
    var ObList = _buildObjData(data)
    ObjGaImpression.ecommerce.impressions.push(ObList);
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }
  }

  var _periodicoPo = function (data, url) {
    const leadPo = document.querySelectorAll('.periodicos .periodicos__portafolio .periodicos__lead')
    Object.keys(leadPo).forEach((key) => {
      let obj = leadPo[key]
      obj.innerHTML = (typeof data.lead !== 'undefined') ? data.lead : ''
    })

    const btnPo = document.querySelectorAll('.periodicos .periodicos__portafolio .periodicos__link')
    Object.keys(btnPo).forEach((key) => {
      let obj = btnPo[key]
      obj.innerHTML = (typeof data.btn_text !== 'undefined') ? data.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(data, "btnPortafolio")
        var scriptTwo = _setGaEvent(data, "clickSuscripcion")
        window.open(url + data.btn_path, '_blank')
      })
    })
    var ObList = _buildObjData(data)
    ObjGaImpression.ecommerce.impressions.push(ObList);
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }
  }

  var _coleccion = function (coleccion, url) {
    if (typeof coleccion.titulo !== 'undefined') {
      $('.colecciones .colecciones__titulo').find('b').html(coleccion.titulo)
    }

    if (typeof coleccion.titulo !== 'undefined') {
      $('.colecciones .colecciones__titulo').find('span').html(coleccion.lead)
    }

    if (typeof coleccion.btn_text !== 'undefined') {
      $('.colecciones .colecciones__link').html(coleccion.btn_text)
      $('.colecciones .colecciones__link').click(function () {
        var script = _clicGaEvent(coleccion, "btnColeccion")
        window.open(url + coleccion.btn_path, '_blank')
      })
    }
    var ObList = _buildObjData(coleccion)
    ObjGaImpression.ecommerce.impressions.push(ObList);
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }

  }

  var _slideRevistasGa = function (data, url) {
    $('.purejscarousel-btn-next').click(function () {
      var classBtn = "purejscarousel-btn-next"
      data.classbtn = classBtn
      var scriptGa = _setGaEvent(data, "slideRevistasNext")
    })
    $('.purejscarousel-btn-prev').click(function () {
      var classBtn = "purejscarousel-btn-prev"
      data.classbtn = classBtn
      var scriptGa = _setGaEvent(data, "slideRevistasPrev")
    })
  }

  var _revistas = function (data, url) {
    (typeof data.donjuan !== 'undefined') ? _donjuan(data.donjuan, url) : false;
    (typeof data.hola !== 'undefined') ? _revHola(data.hola, url) : false;
    (typeof data.alo !== 'undefined') ? _revAlo(data.alo, url) : false;
    (typeof data.bocas !== 'undefined') ? _revBocas(data.bocas, url) : false;
    (typeof data.habitar !== 'undefined') ? _revHabitar(data.habitar, url) : false;
    (typeof data.portafolio !== 'undefined') ? _revPortafolio(data.portafolio, url) : false;
    (typeof data.carrusel !== 'undefined') ? _revCarrusel(data.carrusel, url) : false
    Object.keys(data).forEach((key) => {
      var ObList = _buildObjData(data[key])
      ObjGaImpression.ecommerce.impressions.push(ObList);
    })
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }
  }

  var _donjuan = function (donjuan, url) {
    let lead = document.querySelectorAll('.revistas .revistas__donjuan .revistas__lead')
    Object.keys(lead).forEach((key) => {
      let obj = lead[key]
      obj.innerHTML = (typeof donjuan.lead !== 'undefined') ? donjuan.lead : ''
    })

    let btnText = document.querySelectorAll('.revistas .revistas__donjuan .revista__btn')
    Object.keys(btnText).forEach((key) => {
      let obj = btnText[key]
      obj.innerHTML = (typeof donjuan.btn_text !== 'undefined') ? donjuan.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(donjuan)
        window.open(url + donjuan.btn_path, '_blank')
      })
    })
  }

  var _revHola = function (hola, url) {
    let lead = document.querySelectorAll('.revistas .revistas__hola .revistas__lead')
    Object.keys(lead).forEach((key) => {
      let obj = lead[key]
      obj.innerHTML = (typeof hola.lead !== 'undefined') ? hola.lead : ''
    })

    let btnText = document.querySelectorAll('.revistas .revistas__hola .revista__btn')
    Object.keys(btnText).forEach((key) => {
      let obj = btnText[key]
      obj.innerHTML = (typeof hola.btn_text !== 'undefined') ? hola.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(hola)
        window.open(url + hola.btn_path, '_blank')
      })
    })
  }

  var _revAlo = function (alo, url) {
    let lead = document.querySelectorAll('.revistas .revistas__alo .revistas__lead')
    Object.keys(lead).forEach((key) => {
      let obj = lead[key]
      obj.innerHTML = (typeof alo.lead !== 'undefined') ? alo.lead : ''
    })

    let btnText = document.querySelectorAll('.revistas .revistas__alo .revista__btn')
    Object.keys(btnText).forEach((key) => {
      let obj = btnText[key]
      obj.innerHTML = (typeof alo.btn_text !== 'undefined') ? alo.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(alo)
        var scriptTwo = _setGaEvent(alo, "clickSuscripcion")
        window.open(url + alo.btn_path, '_blank')
      })
    })
  }

  var _revBocas = function (bocas, url) {
    let lead = document.querySelectorAll('.revistas .revistas__bocas .revistas__lead')
    Object.keys(lead).forEach((key) => {
      let obj = lead[key]
      obj.innerHTML = (typeof bocas.lead !== 'undefined') ? bocas.lead : ''
    })

    let btnText = document.querySelectorAll('.revistas .revistas__bocas .revista__btn')
    Object.keys(btnText).forEach((key) => {
      let obj = btnText[key]
      obj.innerHTML = (typeof bocas.btn_text !== 'undefined') ? bocas.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(bocas)
        var scriptTwo = _setGaEvent(bocas, "clickSuscripcion")
        window.open(url + bocas.btn_path, '_blank')
      })
    })
  }

  var _revHabitar = function (habitar, url) {
    let lead = document.querySelectorAll('.revistas .revistas__habitar .revistas__lead')
    Object.keys(lead).forEach((key) => {
      let obj = lead[key]
      obj.innerHTML = (typeof habitar.lead !== 'undefined') ? habitar.lead : ''
    })

    let btnText = document.querySelectorAll('.revistas .revistas__habitar .revista__btn')
    Object.keys(btnText).forEach((key) => {
      let obj = btnText[key]
      obj.innerHTML = (typeof habitar.btn_text !== 'undefined') ? habitar.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(habitar)
        window.open(url + habitar.btn_path, '_blank')
      })
    })
  }

  var _revPortafolio = function (portafolio, url) {
    let lead = document.querySelectorAll('.revistas .revistas__portafolio .revistas__lead')
    Object.keys(lead).forEach((key) => {
      let obj = lead[key]
      obj.innerHTML = (typeof portafolio.lead !== 'undefined') ? portafolio.lead : ''
    })

    let btnText = document.querySelectorAll('.revistas .revistas__portafolio .revista__btn')
    Object.keys(btnText).forEach((key) => {
      let obj = btnText[key]
      obj.innerHTML = (typeof portafolio.btn_text !== 'undefined') ? portafolio.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(portafolio)
        var scriptTwo = _setGaEvent({ ...portafolio, titulo: 'rev_portafolio' }, "clickSuscripcion")
        window.open(url + portafolio.btn_path, '_blank')
      })
    })
  }

  var _revCarrusel = function (carrusel, url) {
    let lead = document.querySelectorAll('.revistas .revistas__carrusel .revistas__lead')
    Object.keys(lead).forEach((key) => {
      let obj = lead[key]
      obj.innerHTML = (typeof carrusel.lead !== 'undefined') ? carrusel.lead : ''
    })

    let btnText = document.querySelectorAll('.revistas .revistas__carrusel .revista__btn')
    Object.keys(btnText).forEach((key) => {
      let obj = btnText[key]
      obj.innerHTML = (typeof carrusel.btn_text !== 'undefined') ? carrusel.btn_text : ''
      obj.addEventListener('click', function (event) {
        var script = _clicGaEvent(carrusel);
        window.open(url + carrusel.btn_path, '_blank')
      })
    })
  }

  var _libros = function (libros, url) {
    if (typeof libros.libro.titulo !== 'undefined') {
      $('.libros .libros__titulo').find('b').html(libros.libro.titulo)
    }

    if (typeof libros.libro.titulo !== 'undefined') {
      $('.libros .libros__titulo').find('span').html(libros.libro.lead)
    }

    if (typeof libros.libro.btn_text !== 'undefined') {
      $('.libros .libros__link').html(libros.libro.btn_text)
      $('.libros .libros__link').click(function () {
        var script = _clicGaEvent(libros.libro)
        window.open(url + libros.libro.btn_path, '_blank')
      })
    }
    var ObList = _buildObjData(libros.libro)
    ObjGaImpression.ecommerce.impressions.push(ObList);
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }
  }

  var _ofertaDestacada = function (data, url) {
    if (typeof data.titulo !== 'undefined') {
      $('.oferta_destacada .titulo__oferta_destacada').html(data.titulo)
    }

    if (typeof data.lead !== 'undefined') {
      $('.oferta_destacada .oferta_destacada__lead').html(data.lead)
    }
    $('.oferta_destacada .oferta_destacada__link').click(function () {
      var script = _clicGaEvent(data)
      var scriptTwo = _setGaEvent(data, "clickSuscripcion")
      window.open(url + data.btn_path, '_blank')
    })

    if (typeof data.btn_path !== 'undefined') {
      $('.oferta_destacada .oferta_destacada__link').html(data.btn_text)
    }

    var ObList = _buildObjData(data);
    ObjGaImpression.ecommerce.impressions.push(ObList);
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }
  }

  var _cursos = function (cursos) {
    if (typeof cursos.curso.titulo !== 'undefined') {
      $('.cursos-cortos .cursos-cortos__titulo').find('p').html(cursos.curso.titulo)
    }

    if (typeof cursos.curso.titulo !== 'undefined') {
      let fields = cursos.curso.lead.split(' ')
      $('.cursos-cortos .cursos-cortos__titulo').find('b').html(fields[0])
      $('.cursos-cortos .cursos-cortos__titulo').find('span').html(fields[1] + " " + fields[2])
    }

    if (typeof cursos.curso.btn_text !== 'undefined') {
      $('.cursos-cortos .cursos-cortos__link').html(cursos.curso.btn_text)
      $('.cursos-cortos .cursos-cortos__link').click(function () {
        var script = _clicGaEvent(cursos.curso)
        window.open(cursos.curso.btn_path, '_blank')
      })
    }
    var ObList = _buildObjData(cursos.curso)

    ObList.brand = 'El Tiempo'

    ObjGaImpression.ecommerce.impressions.push(ObList);
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }
  }

  var _clubVivamos = function (data) {
    if (typeof data.titulo !== 'undefined') {
      $('.club-vivamos .titulo__club-vivamos').html(data.titulo)
    }

    if (typeof data.lead !== 'undefined') {
      $('.club-vivamos .club-vivamos__lead').html(data.lead)
    }

    (typeof data.gastronomia !== 'undefined') ? _clubGastronomia(data.gastronomia) : false;
    (typeof data.turismo !== 'undefined') ? _clubTurismo(data.turismo) : false;
    (typeof data.ropa !== 'undefined') ? _clubRopa(data.ropa) : false;
    (typeof data.salud !== 'undefined') ? _clubSalud(data.salud) : false;
    (typeof data.entretenimiento !== 'undefined') ? _clubEntretenimiento(data.entretenimiento) : false;
    (typeof data.hogar !== 'undefined') ? _clubHogar(data.hogar) : false
  }

  var _clubGastronomia = function (gastronomia) {
    if (typeof gastronomia.btn_text !== 'undefined') {
      $('.club-vivamos__gastronomia .club-vivamos__texto').html(gastronomia.btn_text)
      $('.club-vivamos__gastronomia .club-vivamos__texto, .club-vivamos__gastronomia .club-vivamos__icono').click(function () {
        var scriptGa = _setGaEvent(gastronomia.btn_text, "clubVivamos")
        window.open(gastronomia.btn_path, '_blank')
      })
    }
  }

  var _clubTurismo = function (turismo) {
    if (typeof turismo.btn_text !== 'undefined') {
      $('.club-vivamos__turismo .club-vivamos__texto').html(turismo.btn_text)
      $('.club-vivamos__turismo .club-vivamos__texto, .club-vivamos__turismo .club-vivamos__icono').click(function () {
        var scriptGa = _setGaEvent(turismo.btn_text, "clubVivamos")
        window.open(turismo.btn_path, '_blank')
      })
    }
  }

  var _clubRopa = function (ropa) {
    if (typeof ropa.btn_text !== 'undefined') {
      $('.club-vivamos__ropa .club-vivamos__texto').html(ropa.btn_text)
      $('.club-vivamos__ropa .club-vivamos__texto, .club-vivamos__ropa .club-vivamos__icono').click(function () {
        var scriptGa = _setGaEvent(ropa.btn_text, "clubVivamos")
        window.open(ropa.btn_path, '_blank')
      })
    }
  }

  var _clubSalud = function (salud) {
    if (typeof salud.btn_text !== 'undefined') {
      $('.club-vivamos__salud .club-vivamos__texto').html(salud.btn_text)
      $('.club-vivamos__salud .club-vivamos__texto, .club-vivamos__salud .club-vivamos__icono').click(function () {
        var scriptGa = _setGaEvent(salud.btn_text, "clubVivamos")
        window.open(salud.btn_path, '_blank')
      })
    }
  }

  var _clubEntretenimiento = function (entret) {
    if (typeof entret.btn_text !== 'undefined') {
      $('.club-vivamos__entretenimiento .club-vivamos__texto').html(entret.btn_text)
      $('.club-vivamos__entretenimiento .club-vivamos__texto, .club-vivamos__entretenimiento .club-vivamos__icono').click(function () {
        var scriptGa = _setGaEvent(entret.btn_text, "clubVivamos")
        window.open(entret.btn_path, '_blank')
      })
    }
  }

  var _clubHogar = function (hogar) {
    if (typeof hogar.btn_text !== 'undefined') {
      $('.club-vivamos__hogar .club-vivamos__texto').html(hogar.btn_text)
      $('.club-vivamos__hogar .club-vivamos__texto, .club-vivamos__hogar .club-vivamos__icono').click(function () {
        var scriptGa = _setGaEvent(hogar.btn_text, "clubVivamos")
        window.open(hogar.btn_path, '_blank')
      })
    }
  }

  var _puntosVenta = function (data, url) {
    if (typeof data.puntos.titulo !== 'undefined') {
      $('.club-vivamos__puntos-venta .club-vivamos__titulo').html(data.puntos.titulo)
    }

    if (typeof data.puntos.lead !== 'undefined') {
      $('.club-vivamos__puntos-venta .club-vivamos__mensaje').html(data.puntos.lead)
    }

    if (typeof data.puntos.btn_text !== 'undefined') {
      $('.club-vivamos__puntos-venta .club-vivamos__link2').html(data.puntos.btn_text)
      $('.club-vivamos__puntos-venta .club-vivamos__link2').click(function () {
        var scriptGa = _setGaEvent(data.puntos.btn_text, "puntoVenta")
        window.open(url + data.puntos.btn_path, '_blank')
      })
    }
  }

  var _renovaciones = function (data, url) {
    if (typeof data.renovacion.titulo !== 'undefined') {
      $('.club-vivamos__renovaciones .club-vivamos__titulo').html(data.renovacion.titulo)
    }

    if (typeof data.renovacion.lead !== 'undefined') {
      $('.club-vivamos__renovaciones .club-vivamos__mensaje').html(data.renovacion.lead)
    }

    if (typeof data.renovacion.btn_text !== 'undefined') {
      $('.club-vivamos__renovaciones .club-vivamos__link').html(data.renovacion.btn_text)
      $('.club-vivamos__renovaciones .club-vivamos__link').click(function () {
        data.renovacion.gta_position = 2
        var script = _clicGaEvent(data.renovacion, "btnRenovaciones2")
        var scriptTwo = _setGaEvent(data.renovacion, "renovacionGeneral")
        window.open(url + data.renovacion.btn_path, '_blank')
      })
    }

    (typeof data !== 'undefined') ? _renovacionesDos(data, url) : false;
    (typeof data !== 'undefined') ? _renovacionesHeader(data, url) : false
    data.renovacion.gta_position = 2
    var ObList = _buildObjData(data.renovacion)
    ObjGaImpression.ecommerce.impressions.push(ObList);
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }
  }

  var _renovacionesDos = function (data, url) {
    if (typeof data.renovacion.titulo !== 'undefined') {
      $('.renovaciones .titulo__renovaciones').html(data.renovacion.titulo)
    }

    if (typeof data.renovacion.lead !== 'undefined') {
      $('.renovaciones .renovaciones__lead').html(data.renovacion.lead2)
    }

    if (typeof data.renovacion.btn_text !== 'undefined') {
      $('.renovaciones .renovaciones__lead').find('a').html(data.renovacion.btn_text2)
    }

    if (typeof data.renovacion.btn_path !== 'undefined') {
      $('.renovaciones .renovaciones__btn').html(data.renovacion.btn_text2)
      $('.renovaciones .renovaciones__btn').click(function () {
        data.renovacion.gta_position = 1
        var script = _clicGaEvent(data.renovacion, "btnRenovaciones1")
        var script = _setGaEvent(data.renovacion, "renovacionGeneral")
        window.open(url + data.renovacion.btn_path, '_blank')
      })
    }
    data.renovacion.gta_position = 1
    var ObList = _buildObjData(data.renovacion)
    ObjGaImpression.ecommerce.impressions.push(ObList);
    if (ObjGaImpression.ecommerce.impressions.length > 0) {
      dataLayer.push(ObjGaImpression);
      ObjGaImpression.ecommerce.impressions = []
    }
  }

  var _renovacionesHeader = function (data, url) {
    if (typeof data.renovacion.btn_path !== 'undefined') {
      $('.header .header__boton-suscribete').html(data.renovacion.btn_text)
      $('.header .header__boton-suscribete').click(function () {
        window.open(url + data.renovacion.btn_path, '_blank')
        var scriptGa = _setGaEvent(data.renovacion.btn_path, "renovacion")
        var scriptTwo = _setGaEvent(data.renovacion, "renovacionGeneral")
      })
    }
  }

  var _footer = function (data) {
    let texto01 = document.querySelectorAll('.bottom .bottom__direccion')
    Object.keys(texto01).forEach((key) => {
      let obj = texto01[key]
      obj.innerHTML = (typeof data.texto01 !== 'undefined') ? '<p>' + data.texto01 + '</p>' + '<p>' + data.texto02 + '</p>' + '<p>' + data.texto04 + '</p>' : ''
    })

    if ($('.bottom .bottom__direccion .btn_servicioalcliente').length > 0) {
      $('.bottom .bottom__direccion .btn_servicioalcliente').click(function () {
        var scriptGa = _setGaEvent($(this).text(), "footerServicioCliente")
        window.open(data.url_servicioalcliente, '_blank')
      })
    }

    if (typeof data.telefono01 !== 'undefined') {
      $('.bottom__2 .bottom__telefono1 .bottom__telefono').text(data.telefono01)
    }

    if (typeof data.texto005 !== 'undefined') {
      $('.bottom__2 .bottom__telefono1 .bottom__lead').text(data.texto005)
    }

    if (typeof data.horario !== 'undefined') {
      $('.bottom__2 .bottom__telefono1 .bottom__horario').text(data.horario)
      $('.bottom__2 .bottom__telefono2 .bottom__horario').text(data.horario)
    }

    if (typeof data.telefono02 !== 'undefined') {
      $('.bottom__2 .bottom__telefono2 .bottom__telefono').text(data.telefono02)
    }

    if (typeof data.texto006 !== 'undefined') {
      $('.bottom__2 .bottom__telefono2 .bottom__lead').text(data.texto006)
    }

    if (typeof data.texto007 !== 'undefined') {
      let txtReplace = '__DATE__'
      let temp = _replaceDate(txtReplace, data.texto007)
      $('.footer .footer__copyright').text(temp)
    }
  }

  var _popupcookies = function (data) {
    var validation = _getCookie("cookies-info");
    if (!validation) {
      var elementPopup = document.getElementById('popup-content')
      if (typeof data.popup_content !== 'undefined') {
        elementPopup.innerHTML = '<p>' + data.popup_content + data.learn_more + '</p>';
      }

      if (typeof data.learn_more !== 'undefined') {
        elementPopup.innerHTML = elementPopup.innerHTML + data.understand_btn
      }

      $('.popup-content .understand-btn').click(function () {
        _setCookie("cookies-info", true, 90)
        _setGaEvent(null, 'clickAcceptCookies')
        $('.popup').hide()
      })
    } else {
      $('.popup').hide()
    }
  }

  // Función para obtener el valor de una cookie por su nombre
  var _getCookie = function (name) {
    var cookies = document.cookie
    var nameEQ = name + "="
    var cookiesArray = cookies.split(';')
    for (var i = 0; i < cookiesArray.length; i++) {
      var cookie = cookiesArray[i]
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1, cookie.length)
      }
      if (cookie.indexOf(nameEQ) == 0) {
        return cookie.substring(nameEQ.length, cookie.length)
      }
    }
    return null;
  }

  // Función para establecer una cookie
  var _setCookie = function (name, value, expirationDay) {
    var expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (expirationDay * 24 * 60 * 60 * 1000))
    var expiration = "expires=" + expirationDate.toUTCString()
    document.cookie = name + "=" + value + ";" + expiration + ";path=/"
  }


  var _replaceDate = function (replace, text) {
    let yearNow = new Date().getFullYear()
    text = text.replace(/__DATE__/g, yearNow)
    return text
  }

  var _buildObjData = function (data) {
    var list = data.gta_list
    var position = data.gta_position
    var name = data.btn_text
    var brand = data.titulo
    if (data.gta_id !== undefined) {
      if (data.gta_id == 'renovacion') {
        var id = data.gta_id + position
      } else {
        var id = data.gta_id
      }
    } else {
      var id = data.titulo + position
    }
    var category = data.gta_category

    ObjList = {
      name: name,
      id: id,
      brand: brand,
      category: category,
      list: list,
      position: position
    }
    return ObjList
  }

  var _setGaEvent = function (data, typeCont) {
    var scriptData = ''
    if (typeCont == 'footerServicioCliente') {
      scriptData = dataLayer.push({ 'event': 'ga_event', 'category': 'Footer', 'action': 'SET - Footer Email', 'label': data })
    }
    if (typeCont == 'clubVivamos') {
      scriptData = dataLayer.push({ 'event': 'ga_event', 'category': 'Club Suscriptores', 'action': 'SET - Club Suscriptores', 'label': data })
    }
    if (typeCont == 'renovacionHeader') {
      scriptData = dataLayer.push({ 'event': 'ga_event', 'category': 'Header', 'action': 'SET - Renueva Suscripcion', 'label': 'Renueva tu suscripcion' })
    }

    if (typeCont == 'renovacionGeneral') {
      scriptData = dataLayer.push({ 'event': 'ga_event', 'name_event': 'clic_renovaciones' });
    }

    if (typeCont == 'slideRevistasNext') {
      var label = 'Next'
      scriptData = dataLayer.push({ 'event': 'ga_event', 'category': 'Revistas carrusel', 'action': 'SET - Slider-' + data.classbtn, 'label': label })
    }
    if (typeCont == 'slideRevistasPrev') {
      var label = 'Back'
      scriptData = dataLayer.push({ 'event': 'ga_event', 'category': 'Revistas carrusel', 'action': 'SET - Slider-' + data.classbtn, 'label': label })
    }
    if (typeCont == 'puntoVenta') {
      scriptData = dataLayer.push({ 'event': 'ga_event', 'category': 'Puntos de Venta', 'action': 'SET - Ir A Tienda', 'label': data })
    }

    if (typeCont == 'clickSuscripcion') {
      scriptData = dataLayer.push({ 'event': 'ga_event', 'name_event': 'clic_suscripcion_' + data.titulo.replace(/ /g, "_").toLowerCase() })
    }

    if (typeCont == 'clickAcceptCookies') {
      scriptData = dataLayer.push({ 'event': 'aceptacion_cookies' })
    }

    return scriptData
  }

  var _clicGaEvent = function (data, typeCont) {
    var list = data.gta_list
    var position = data.gta_position
    var name = data.btn_text
    var brand = data.titulo
    if (data.gta_id !== undefined) {
      if (data.gta_id == 'renovacion') {
        var id = data.gta_id + position
      } else {
        var id = data.gta_id
      }
    } else {
      var id = data.titulo + position
    }

    var category = data.gta_category

    ObjList = {
      name: name,
      id: id,
      brand: brand,
      category: category,
      list: list,
      position: position
    }
    ObjGaClic.label = 'boton - ' + name
    ObjGaClic.ecommerce.promoClick.promotions.push(ObjList);

    var scriptData = ''
    scriptData = dataLayer.push(ObjGaClic)
    ObjGaClic.ecommerce.promoClick.promotions = []

    return scriptData
  }

  return {
    load: init
  }
})()

$(document).ready(homeSuscripciones.load)